import React, { memo, useCallback, useState } from 'react';
import { ix } from '../../../../../../utils/ix';
import { BaseFilterMenu } from '../../../BaseFilterMenu';
import { AddFilterChip } from './components/AddFilterChip';
import { AddFilterMenuContent } from './components/AddFilterMenuContent';
export const AddFilterMenu = memo(({ id, className, fieldNameOptions, onClick }) => {
    const [isOpen, setOpen] = useState(false);
    const handleChipClick = useCallback(() => {
        setOpen(!isOpen);
    }, [isOpen]);
    const handleClose = useCallback(() => {
        setOpen(false);
    }, []);
    const handleOnClick = useCallback((fieldNameOption) => {
        onClick(fieldNameOption);
        setOpen(false);
    }, [onClick]);
    return (React.createElement(BaseFilterMenu, { id: id, className: className, open: isOpen, onChipClick: handleChipClick, onClose: handleClose, chipContent: React.createElement(AddFilterChip, { id: ix(id, 'add-filter-chip') }), menuContent: React.createElement(AddFilterMenuContent, { id: ix(id, 'add-filter-menu-content'), isOpen: isOpen, fieldNameOptions: fieldNameOptions, onClick: handleOnClick }) }));
});
//# sourceMappingURL=AddFilterMenu.js.map